// qcStatus.ts
import type { QCStatus } from '@/types';

const VALID: readonly QCStatus[] = ['Pass', 'Fail', 'Partial', 'N/A'];

export function toQCStatus(value: string | null | undefined): QCStatus | null {
  if (value === null || value === undefined) return null;
  return VALID.includes(value as QCStatus) ? (value as QCStatus) : null;
}
